import React from 'react';
import Cookies from 'universal-cookie';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';
import ProductDetails from '../product/ProductDetails';

const cookies = new Cookies();

class Pedidos extends React.Component{
    constructor(props){
        super(props);
        this.state={
            id:cookies.get("id"),
            last_name:"",
            email:"",
            phone_number:"",
            password:"",
            password_confirmation:"",
            address:"",
            pais:"",
            distrito:"",
            loading:false,
            message_serve:"",
            message_serve_e:"",
            pedidos:[],
            compra_s:0,
            compra_e:0,
            compra_en:0,
            compra_a:0
        }
    }
    
    componentDidMount() {
        if(cookies.get('id')){

            
            API.PRODUCTS.post(`pedidos_compra`,{
                id:this.state.id,
            })
             .then(resp =>{
                
                console.log(resp);
                this.setState({
                    pedidos:resp.data.compra,
                    compra_s:resp.data.compra_s,
                    compra_e:resp.data.compra_e,
                    compra_en:resp.data.compra_en,
                    compra_a:resp.data.compra_a
                });
             })
             .catch(err =>{
                 
                 console.log(err);
             });
          
        }else{
            window.location.href="/";
        }

    }
    

 

    render(){
        return(
            
            <div className="container-fluid mt-2 mb-3">
                <div className="col-12">
                    <div className="col-md-10 col-sm-12 mx-auto"> 
                        
                        <div className="col-md-12 col-sm-12 border-solid">
                            
                            <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade show active datos-div" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <p className="editar-text">Pedidos</p>   
                                <hr></hr>
                                <p className="text-datos">Pedidos</p>
                                <div className="estados">   
                                    <p>Solicitado({this.state.compra_s})</p>
                                    <p>Enviado({this.state.compra_e})</p>
                                    <p>Entregado({this.state.compra_en})</p>
                                    <p>Anulado({this.state.compra_a})</p>
                                </div>

                                <table className="table">
                                <thead>
                                    <tr>
                                    <th>Información</th>
                                    <th >Estado</th>
                                    <th >Dirección</th>
                                    <th >Constancia</th>
                                    <th >Productos</th>
                                    <th >Importe total</th>
                                    </tr>
                                </thead>
                                <tbody>

                                {this.state.pedidos.map((ped,index) =>(
                                        <tr key={index}>
                                        <td >
                                            <p className="td_p"><span className="c_gris">N.º pedido: </span> {992589+ped.id} <a href={"/user/productos/"+(992589+ped.id)}>Ver detalles</a></p>
                                            <p className="td_p"><span className="c_gris">Fecha y hora del pedido:</span> {ped.created_at}</p>
                                        
                                        </td>
                                        <td>
                                            {ped.compra_estado_id==1
                                            ? 
                                            <p className="estado es_s">{ped.estado.nombre}</p>
                                            :
                                            ped.compra_estado_id==2
                                            ? 
                                            <p className="estado es_e">{ped.estado.nombre}</p>
                                            :
                                            ped.compra_estado_id==3
                                            ?
                                            <p className="estado es_en">{ped.estado.nombre}</p>
                                            :
                                            <p className="estado es_a">{ped.estado.nombre}</p>
                                            }

                                            
                                            
                                            
                                        </td>
                                        <td>
                                            <p className="td_p">{ped.distrito.nombre}</p>
                                            <p className="td_p">{ped.address}</p>
                                        </td>
                                        <td >
                                            {ped.constancia==1?
                                            <p className="estado">BOLETA / {ped.dni}</p>
                                            :
                                            <p className="estado">FACTURA / {ped.ruc}</p>
                                            }
                                            
                                        </td>
                                        <td><a href={"/user/productos/"+(992589+ped.id)}>Ver Productos</a></td>
                                        <td className="estado i_total es_a">S/. {ped.amount}</td>
                                        </tr>
                                  ))}   
                                </tbody>
                                </table>

                                {this.state.pedidos.length>0?
                                ""
                                
                                :
                                <div class="col-md-10 mx-auto">
                                    <p class="p-tienda"> Aún no se ah registrado ningún pedido le invitamos pasar por nuestra <a href="/productos">Tienda Virtual</a></p>
                                </div>
                                
                                }
                            </div>
                            </div>
                        </div>
                       
                    </div> 
                   
                </div>
            </div>
           
        );
    
}

}
export default Pedidos;